module.exports = __webpack_public_path__ + "static/media/Army_A.5c43f4c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Army_A.svg
// module id = 296
// module chunks = 0